import React, { useContext, useEffect, useState } from "react";
import './style.css';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faSignOutAlt, faHeadset, faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { AppContext } from "../../AppContext";
import { styled } from 'styled-components';
import { useRecoilState } from 'recoil';
import { FiMenu } from 'react-icons/fi';
import { sidebarCollapsedAtom } from '../../atoms/uiAtom';
import Logo from "../../images/logo.png";
export default function Navigator() {
  const [isVisible, setIsVisible] = useState(true);
  const [, setSidebarCollapsed] = useRecoilState(sidebarCollapsedAtom);
  const { isLoggedIn, logout, user } = useContext(AppContext);
  const [menuItems, setMenuItems] = useState([]);
  const navigate = useNavigate(); // useNavigate 훅 사용

  
  useEffect(() => {
    const fetchMenuItems = async () => {
      try {
        const response = await fetch('/request/getMenuItems');
        const data = await response.json();
        setMenuItems(data);
      } catch (error) {
        console.error('Error fetching menu items:', error);
      }
    };

    fetchMenuItems();
  }, []);

  const handleLogout = async () => {
    try {
      const response = await fetch('/request/logout', { 
        credentials: 'include',method: 'GET' });

      if (response.ok) {
        logout();
        sessionStorage.removeItem('user');
      } else {
        console.error('Failed to logout');
      }
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };

  const handleNavigate = (path, state) => {
    navigate(path, { state });
  };

  const AccountBox = styled.div`
    a {
      color: white; 
      text-decoration: none; 

      &:visited {
        color: white; 
      }

      &:hover {
        color: darkblue; 
      }

      &:active {
        color: darkblue; 
      }
    }
  `;

  const InquiryButton = styled.div`
    cursor: pointer;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    font-size: 14px;
    position: fixed;
    bottom: 3rem;
    background: white;
    color: black;
    border-radius: 4rem;
    padding: 15px 17px 15px 30px;
    left: 3rem;
    z-index: 100;
    transform: ${(props) => (props.isVisible ? 'translateX(0)' : 'translateX(-110%)')}; 
    transition: transform 1.5s ease;
    &:hover {
      background: #f0f0f0;
      color: #007bff;
    }
  `;

  const ArrowButton = styled.div`
    margin-left: 20px;
    cursor: pointer;
    font-size: 16px;
  `;

  const HamburgerBtn = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 38px;
    height: 38px;
    margin: 0 10px 0 6px;
    flex: 0 0 auto;
    background: rgba(255, 255, 255, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.16);
    border-radius: 10px;
    color: #fff;
    cursor: pointer;
    font-size: 20px;
    transition: background 0.2s ease, border-color 0.2s ease;
    &:hover {
      background: rgba(255, 255, 255, 0.18);
      border-color: rgba(255, 255, 255, 0.35);
    }
  `;

  return (
    <div className='menu'>
      <InquiryButton isVisible={isVisible} onClick={toggleVisibility}>
        <div style={{ display: 'flex', justifyContent: 'space-between', whiteSpace: 'nowrap', alignItems: 'center' }}>
          <div onClick={() => handleNavigate(`/Control/Board/cs_onetoone`, { fromNavigator: true })}>
            <FontAwesomeIcon icon={faHeadset} /> 1:1문의 
          </div>
          <ArrowButton>
            <FontAwesomeIcon icon={isVisible ? faChevronLeft : faChevronRight} />
          </ArrowButton>
        </div>
      </InquiryButton>
      <div className='leftLogo'>
        <div onClick={() => handleNavigate('/', { fromNavigator: true })}>
          <img src={Logo} alt='로고' />
        </div>
      </div>
      {/* 오른쪽 메뉴 */}
      <ul className='rightNav'>
        {menuItems.map(item => (
          <li key={item.std_id}>
            <div 
              onClick={() => handleNavigate(`/${item.std_value}`, { fromNavigator: true })} 
            >
              {item.std_key}
            </div>
          </li>
        ))}
        <HamburgerBtn
          onClick={() => setSidebarCollapsed((c) => !c)}
          title="메뉴 접기/펼치기"
          aria-label="메뉴 접기/펼치기"
        >
          <FiMenu />
        </HamburgerBtn>
        <a style={{ position: 'absolute', fontSize: '12px', top: '0px', right: '0px' }}>{user?.domain}</a>
      </ul>
    </div>
  );
}